export enum AuthorizationTypeEnum {
    Internal = 1,
    Microsoft = 2,
    Google = 3,
    Application = 4
}
